<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <mat-card class="card-general">
      <mat-card-title>Anclas / Aditamentos (Attachments)</mat-card-title>
      <mat-card-content class="row w-100 w-sm-75 mt-2">
          <div class="row w-100 w-sm-75 justify-content-start">
            <p class="col text-start">¿Deseas colocar Anclas de resina dentales?</p>
            <mat-radio-group aria-label="Seleciona una opción" formControlName="useDentalResinAnchors" class="col d-flex flex-wrap gap-4">
              <div class="row gx-4 gy-2" *ngFor="let item of booleanOptions">
                <mat-radio-button [value]="item.value"
                  [checked]="item.value == getControl(stepFormGroup,'useDentalResinAnchors')" (click)="resetFormControl(stepFormGroup, 'stage')" class="col py-6"
                ><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
          <div class="row justify-content-start" *ngIf="getControl(stepFormGroup,'useDentalResinAnchors')">
            <div style="width: fit-content;" class="d-flex">
              Colocar Anclas a partir del alineador
                #
                <mat-radio-group aria-label="Seleciona una opción" formControlName="stage" class="col d-flex flex-wrap gap-4">
                  <div class="row gx-4" *ngFor="let item of selectStageOptions">
                    <mat-radio-button [value]="item.value"
                      [checked]="item.value == getControl(stepFormGroup,'stage')" (click)="resetFormControl(stepFormGroup, 'stage')" class="col py-6"
                    ><span style="white-space:normal;">{{item.display}}</span>
                    </mat-radio-button>

                  </div>
                  <mat-radio-button [value]="customStageNumber">
                      <input class="custom-stage-number" #customStageNumberInput min="3" type="number"  name="customStageNumber" [(ngModel)]="customStageNumber" [ngModelOptions]="{standalone: true}" (input)="onCustomStageChange(customStageNumberInput.value)">
                  </mat-radio-button>
                </mat-radio-group>
              </div>
          </div>
      </mat-card-content>
    </mat-card>

    <div>
      <div class="row justify-content-start">
        <mat-checkbox formControlName="isNoPlaceDentalAnchors" style="width: fit-content;"><span style="white-space: normal;">No colocar anclas dentales en los dientes  indicados a continuación</span></mat-checkbox>
      </div>
      <div class="row justify-content-center mt-4" *ngIf="getControl(stepFormGroup,'isNoPlaceDentalAnchors')">
        <app-pieces-container [selectedPieces]="stepFormGroup?.controls['noPlaceDentalAnchorsPieces'].value" style="overflow-x: auto;" [numberPieces]=7 (piecesSelected)="onSetPieces($event, stepFormGroup, 'noPlaceDentalAnchorsPieces')"></app-pieces-container>
      </div>
    </div>

    <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="dentalAnchorsComments" formControlName="dentalAnchorsComments" style="height: 120px;"></textarea>

    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <button mat-button matStepperNext data-testid="nextStep8" class="button secondary-button" (click)="updateStepPrescription()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
    </div>
  </form>
</div>
